<template lang="pug">
  header
    .nav(v-if="width <= 768")
      .nav-link
        .columns.is-mobile.is-vcentered
          .column.to-click
            img.re-mobile(@click="goHome", src="../../../static/images/pontotel-branco.png")
          .column.to-click
            img.re-mobile.client(@click="goHome", :src="visual.clientLogo")

          span.toogle.to-click(@click="toggle=!toggle")
            font-awesome-icon(icon="bars")

    .columns.is-vcentered.is-size-6(v-if="toggle || width > 768")
      .column

      .column.has-text-centered.to-click(v-if="width > 768", style="padding:0;")
        img.re-mobile.ml(@click="goHome", src="../../../static/images/pontotel-branco.png")

      template(v-if="info")
        .column.has-text-centered(v-if="info.employeeName")
          .row(v-if="visual.webEmployeeNickname")
            span.employee-name Olá, {{info.employeeNickName}}
          .row(v-else)
            span.employee-name Olá, {{info.employeeName}}
          .row(v-if="info.employerName && visual.webEmployerName")
            small.auxiliar-text {{info.employerName}}

        .column.has-text-centered.infos-wrapper(v-if="visual.webShowCompanyTextHeader && info.companies[0]")

          span(v-if="info.companies.length") Locais de Trabalho: {{ info.companies[0] }}

          button.button.to-click.all-companies(title="Mostrar todos os locais habilitados",
            v-if="info.companies.length > 1", @click="showCompanies") +

        modal(name="companiesModal", :adaptive="true" width="25%" height="auto", :scrollable="true")
          CompaniesBox

      .column.has-text-centered(v-if="this.width > 768 && visual.clientLogo" )
        img.re-mobile.client.ml(:src="visual.clientLogo")

      .column.has-text-centered(v-if="this.width > 768 && !visual.clientLogo" )
        .row(v-if="visual.webButtonAccessSystem")
          span &nbsp;
        .row(v-if="visual.webButtonAccessSystem")
          span.go-to-app.to-click(@click="goToApp") Acesse o sistema

      .column.has-text-centered
        .row(v-if="visual.webButtonLogout && (visual.clientLogo || this.width < 768)")
          span  &nbsp;
        .row(v-if="visual.webButtonLogout && (visual.clientLogo || this.width < 768)")
          span.go-to-app.to-click(@click="goToApp") Acesse o sistema
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CompaniesBox from './CompaniesBox.vue'
import router from '../../router/router'
import config from '../../config'
import { API } from '../../services'
import Toasted from 'vue-toasted';
import Vue from 'vue'

Vue.use(Toasted)

export default {
  data () {
    return {
      width: 0,
      toggle: true
    }
  },
  created () {
    this.checkVersion()
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    CompaniesBox
  },
  computed: {
    ...mapState('punchTimelog', ['employee']),
    ...mapGetters(['visual']),
    info () {
      const {accessData} = this.$store.state
      if (!accessData.browserRecord) { return null }
      return {
        compManName: accessData.compMan.displayName,
        employeeName: this.employee ? this.employee.name : '',
        employeeNickName: this.employee ? this.employee.nickname : '',
        employerName: this.employee ? this.employee.employer : '',
        companies: accessData.browserRecord.companies.map(i => i.name),
        pts: this.$store.state.punchTimelog.monthPts
      }
    },
    displayShowPtsButton () {
      return this.$route.name === 'Pts'
    },
    isBV () {
      if (this.$store.state.accessData && this.$store.state.accessData.compMan) {
        return this.$store.state.accessData.compMan.id === '5cd49411d28021000c09e013'
      } else {
        return false
      }
    },
    isNubank () {
      if (this.$store.state.accessData && this.$store.state.accessData.compMan) {
        return this.$store.state.accessData.compMan.id === '56d7358536a3b600dc7e2b3e'
      } else {
        return false
      }
    }
  },
  methods: {
    logout () {
      this.$router.push('/logout')
    },
    home () {
      this.$router.push('/password')
    },
    handleResize () {
      this.width = window.innerWidth
      if (this.width <= 768) {
        this.toggle = false
      }
    },
    checkVersion () {
      try {
        API.getS3File.get('https://lar21css.s3-sa-east-1.amazonaws.com/new-web-version')
          .then((response) => {
            const newVersion = Number(response.data)
            const appVersion = Number(config.version.split('.').join(''))
            if (newVersion > appVersion) {
              Vue.toasted.show('Uma nova versão do PontoTel Web foi lançada!', {
                position: 'top-right',
                iconPack : 'material',
                singleton: true,
                action: {
                  text: 'Atualizar',
                  onClick: (e, toastObject) => {
                    location.reload(true)
                    toastObject.goAway(0)
                  }
                }
              })
            } else {
              console.info('PontoTel Web is up to date!')
            }
          })
          .catch((error) => {
            console.warn('xx version not found')
          })
      } catch (e) {
        console.warn('yy version not found')
      }
    },
    showCompanies () {
      this.$modal.show('companiesModal')
    },
    goHome () {
      if (location.href.includes('localhost')) {
        router.push({name: 'password'})
      } else if (location.href.includes('hml.pontotel.com.br/pontotel/new-web')) {
        if (this.isBV) {
          window.location.replace('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/web/BancoVotorantim')
        } else if (this.isNubank) {
          window.location.replace('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/web/nubank-pontotel')
        } else {
          router.push({name: 'password'})
        }
      } else if (location.href.includes('new-web.pontotel.com.br')) {
        if (this.isBV) {
          window.location.replace('https://back.pontotel.com.br/api/redirect-saml/web/BancoVotorantim')
        } else if (this.isNubank) {
          window.location.replace('https://back.pontotel.com.br/api/redirect-saml/web/nubank-pontotel')
        } else {
          router.push({name: 'password'})
        }
      }
    },
    goToApp () {
      if (location.href.includes('localhost')) {
        window.open('http://localhost:8081', '_blank')
      } else if (location.href.includes('hml.pontotel.com.br/pontotel/new-web')) {
        if (this.isBV) {
          window.open('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/app/BancoVotorantim', '_blank')
        } else if (this.isNubank) {
          window.open('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/app/nubank-pontotel', '_blank')
        } else {
          window.open('https://homolog.pontotel.com.br', '_blank')
        }
      } else if (location.href.includes('bv-web.pontotel.com.br')) {
        if (this.isBV) {
          window.open('https://back.pontotel.com.br/api/redirect-saml/app/BancoVotorantim', '_blank')
        } else {
          window.open('https://gestao.pontotel.com.br', '_blank')
        }
      } else {
        if (this.isBV) {
          window.open('https://back.pontotel.com.br/api/redirect-saml/app/BancoVotorantim', '_blank')
        } else if (this.isNubank) {
          window.open('https://back.pontotel.com.br/api/redirect-saml/app/nubank-pontotel', '_blank')
        } else {
          window.open('https://gestao.pontotel.com.br', '_blank')
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

header {
  background-color: var(--web-color-header);
  width: 100%;
  padding: 1px;
  min-height: 68px;
  display: grid;
  align-items: center;
  height: 100%;
}
header  > * {
  color: var(--web-color-font-header);
}

.none {
  display: none
}

.employee-name {
  font-size: 18px;
  font-weight: bold;
  font-stretch: condensed;
}

.auxiliar-text {
  font-size: 16px;
  font-weight: lighter;
  font-stretch: condensed;
}

.go-to-app {
  font-size: 16px;
  font-weight: lighter;
  font-stretch: condensed;
}

.go-to-app:hover {
  color: var(--color-warning);
  border-bottom: 2px solid var(--color-warning);
}

.nav-link-toggle {
  align-self: flex-end;
  display: initial;
  position: absolute;
  cursor: pointer;
}
.nav-items, .nav {
  display: flex;
  flex-direction: column;
}
.nav-items-right {
  margin-left: 0;
}

.capitalize {
  text-transform: uppercase;
}

.toogle {
  font-size: 40px;
  padding-right: 15px;
}

.p8 {
  padding-top: 8px;
  padding-right: 10px;
  padding-left: 10px;
  padding-bottom: 8px;
  font-size: 12px;
}
.ma {
  margin: auto;
}
.flex {
  display: flex;
}

.all-companies {
  height: 30px;
  width: 30px;
  padding: 0;
  border-radius: 0;
}
.infos-wrapper {
  display: grid;
  grid-template-columns: auto auto auto;
  align-items: center;
}

@media only screen and (min-width: 320px)  {

  img.re-mobile {
    max-width: 111px;
    max-height: 60px;
  }

  img.re-mobile.client {
    max-width: 111px;
    max-height: 60px;
    min-height: 25px;
  }
}

@media (min-width: 768px) {

  img.re-mobile {
    max-width: 111px;
    max-height: 80px;
  }

  img.re-mobile.client {
    max-width: 111px;
    max-height: 60px;
    min-height: 30px;
  }

}

@media (min-width: 960px) {

  img.re-mobile {
    max-width: 111px;
    max-height: 80px;
  }

  img.re-mobile.client {
    max-width: 111px;
    max-height: 60px;
    min-height: 35px;
  }

}

@media only screen and (min-width: 1024px) {
  img.re-mobile {
    max-width: 111px;
    max-height: 80px;
  }

  img.re-mobile.client {
    max-width: 111px;
    max-height: 60px;
    min-height: 35px;
  }

}

@media only screen and (min-width: 1900px) {
  img.re-mobile {
    max-width: 111px;
    max-height: 80px;
  }

  img.re-mobile.client {
    max-width: 111px;
    max-height: 60px;
    min-height: 35px;
  }
}
</style>
